/* @flow */

import { bgColor, textColor } from 'plugin/light/style/color';

export default {
  root: {
    height: '100%',
    minHeight: '100vh',
    padding: [20, 40],

    backgroundColor: bgColor,
    color: textColor,
  },
};
